import { z } from 'zod';

/** Moves the siege engine accepts. Must match game-core's `SiegeMove`. */
export const siegeMoveSchemas = [
  z.object({ type: z.literal('loose'), weight: z.number().min(1).max(10), angle: z.number().int().min(15).max(75) }),
] as const;

const point = z.tuple([z.number(), z.number()]);

export const siegeViewSchema = z.object({
  wallX: z.number(),
  wallWidth: z.number(),
  wallHeight: z.number(),
  upper: z.number(),
  hp: z.number().int(),
  maxHp: z.number().int(),
  wind: z.number(),
  shot: z.number().int(),
  shots: z.number().int(),
  trails: z.array(z.array(point)),
  last: z.object({ hit: z.number().int(), short: z.boolean(), weight: z.number(), angle: z.number() }).nullable(),
  over: z.boolean(),
});
export type SiegeView = z.infer<typeof siegeViewSchema>;
